import React, { useState, useEffect } from 'react'
import styles from "./MainPersonal.module.css";
import { Link } from 'react-router-dom';

import GetHeader from '../helper/getHeader/GetHeader';
import BtnBack from '../helper/btnBackMTO/BtnBack';

import bg_main_2 from '../../../assets/dashboard/bg_main_2.png'
import bg from '../../../assets/dashboard/background.png'
import medal from '../../../assets/dashboard/medal.png'
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { getUniversity } from '../../../actions/report'
import { BACKEND_URL_PREFIX } from '../../../utils/const';
import { store } from '../../App';
import { signOut } from '../../../actions/auth';

const MainPersonal = ({
    university,
    getUniversity,
    ...props
}) => {

    const [uni, setUni] = useState(null);
    const [logo, setLogo] = useState('');
    const dispatch = store.dispatch;
    const { id } = props.match.params
    const history = props.history

    useEffect(() => {
        getUniversity();
    }, [id]);

    useEffect(() => {
        if (university && university.length > 0 && id != null) {

            const one = id.split('_')[0] || null;
            const two = id.split('_')[1] || null;

            const univer = two ? university[one].branches[two] : university[one]
            setUni(univer)
        }
    }, [university]);

    useEffect(() => {
        const prefix = uni?.api_url
        if (prefix?.length > 1 && uni != 'all') {
            const url = `${prefix}company/gou_logo`
            fetch(url)
                .then(resp => resp.blob())
                .then(myBlob => setLogo(URL.createObjectURL(myBlob)))
        } else {
            const url = `${BACKEND_URL_PREFIX}/company/gou_logo`
            fetch(url)
                .then(resp => resp.blob())
                .then(myBlob => setLogo(URL.createObjectURL(myBlob)))
        }
    }, [uni])

    useEffect(() => {
        if (id == 'all') {
            const url = `${BACKEND_URL_PREFIX}/token`;
            fetch(url)
                .then(resp => resp.blob())
                .then(myBlob => console.log(URL.createObjectURL(myBlob)))
        }
    }, [id]);


    useEffect(() => {
        const someValue = store.getState().auth.access_modes?.['Режимы']?.['Показатели деятельности вуза']
        if (someValue != 'Полный' && id == 'all') {
            dispatch(signOut(history))
        }
    }, []);

    return (
        <div className={styles.wrapper}>
            <img src={bg} className={styles.bg} />

            <GetHeader title={<>СЕТЬ ОБРАЗОВАТЕЛЬНЫХ ОРГАНИЗАЦИЙ ВЫСШЕГО ОБРАЗОВАНИЯ <br /> МИНОБОРОНЫ РОССИИ</>} />

            <div className={styles.wrapperBlock}>
                <Link to={`${id}/main`}>
                    <div className={styles.blockItem}>
                        <img src={bg_main_2} className={styles.card} />
                        <p>Показатели деятельности {uni?.name}</p>
                        <img
                            src={logo}
                            className={styles.medal}
                        />
                    </div>
                </Link>

                <Link to={`${id}/facs`}>
                    <div className={styles.blockItem}>
                        <img src={bg_main_2} className={styles.card} />
                        <p>Показатели деятельности факультетов/кафедр</p>
                        <img
                            src={logo}
                            className={styles.medal}
                        />
                    </div>
                </Link>

                <Link to={`${id}/kaf`}>
                    <div className={styles.blockItem}>
                        <img src={bg_main_2} className={styles.card} />
                        <p>Военно-профессиональный портрет обучающегося</p>
                        <img
                            src={logo}
                            className={styles.medal}
                        />
                    </div>
                </Link>
            </div>

            <BtnBack />
        </div>
    )
}

const mapStateToProps = (state) => ({
    university: state.report.university
});

export default withRouter(connect(mapStateToProps, { getUniversity })(MainPersonal));